import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  dialogTitleRoot: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
}));

interface Props extends DialogTitleProps {
  children: React.ReactNode;
}

function DialogLayoutTitle({ children, ...others }: Props) {
  const classes = useStyles();

  return (
    <DialogTitle classes={{ root: classes.dialogTitleRoot }} id="draggable-dialog-title" {...others}>
      {children}
    </DialogTitle>
  );
}

export default DialogLayoutTitle;
